import { z } from 'zod';
import { Contact, Place } from './common';
export var SocialDistractionContact = Contact;
export var SocialDistractionPlace = Place;
export var SocialDistractions = z.object({
    contacts: z.array(SocialDistractionContact).prefault([]),
    places: z.array(SocialDistractionPlace).prefault([])
}).prefault({
    contacts: [],
    places: []
});
